import React from 'react';

/**
 * STEELPEAK brand mark. Both assets sit on a dark navy background baked
 * into the PNG, so they read best against navy or as a small navy chip on
 * light backgrounds.
 *
 * variant="mark"      → square STPK badge (nav, favicons, mobile compact)
 * variant="wordmark"  → full "STEELPEAK" wordmark (dark hero panels)
 */
export function Logo({ variant = 'mark', className = '', alt = 'STEELPEAK' }) {
  const src =
    variant === 'wordmark' ? '/logos/steelpeak-wordmark.png' : '/logos/stpk-mark.png';
  return (
    <img
      src={src}
      alt={alt}
      draggable={false}
      className={`select-none ${className}`}
    />
  );
}
